import { useEffect } from 'react'

import { useGrowthBook } from '@growthbook/growthbook-react'

import { getIsNewUserForTikTokMinBudget } from 'src/Redux/auth-process/userSlice/selectors'
import {
  hasPayedTikTokCampaigns,
  useMetadataQuery,
} from 'src/Redux/metadataApi'
import {
  useUpdateArtistFeatureFlagsMutation,
  useGetArtistFeatureFlagsQuery,
} from 'src/Redux/A-BFeaturesApi'

import { useAppSelector } from '../redux'

const TIKTOK_MIN_BUDGET_FEATURE_NAME = 'tiktok_campaign_min_budget_group'
const TIKTOK_MIN_BUDGET_BE_FEATURE_NAME = 'tiktok_campaign_min_budget_group'

export const useTikTokCampaignMinBudgetExperiment = (): null => {
  const growthbook = useGrowthBook()
  const isGrowthBookReady = growthbook.ready
  const { data: metadata } = useMetadataQuery()

  const hasPayedTikTok = hasPayedTikTokCampaigns(metadata)

  const [addFeatureForUser] = useUpdateArtistFeatureFlagsMutation()

  const isNewUser = useAppSelector(getIsNewUserForTikTokMinBudget)

  const { data: featureValue, isSuccess: featuresIsSucceeded } =
    useGetArtistFeatureFlagsQuery(void 0, {
      selectFromResult: (result) => ({
        ...result,
        data: result?.data?.features?.find(
          (item) => item?.name === TIKTOK_MIN_BUDGET_BE_FEATURE_NAME,
        )?.variation,
      }),
    })

  useEffect(() => {
    const isValidUser = isNewUser && !hasPayedTikTok

    const isFeatureNeeded =
      featuresIsSucceeded && !featureValue && isValidUser && isGrowthBookReady

    if (isFeatureNeeded) {
      const variant = growthbook.getFeatureValue(
        TIKTOK_MIN_BUDGET_FEATURE_NAME,
        0,
      )

      addFeatureForUser({
        featureName: TIKTOK_MIN_BUDGET_BE_FEATURE_NAME,
        variation: Number(variant),
      })
    }
  }, [
    addFeatureForUser,
    featureValue,
    featuresIsSucceeded,
    growthbook,
    isGrowthBookReady,
    hasPayedTikTok,
    isNewUser,
  ])

  return null
}
